module.exports = __webpack_public_path__ + "static/undraw_status_update_jjgk-00b1b26dcff30fb129184bd07e71b17d.svg";